exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "dimensions-editor {\n  display: block;\n  padding-left: 5px;\n}\ndimensions-editor h5 {\n  margin-bottom: 0;\n}\ndimensions-editor .dimensions-row {\n  margin-top: 5px;\n  margin-left: -20px;\n}\ndimensions-editor .add-new {\n  margin-left: 0;\n  padding: 4px;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/upsert/alarm/dimensionsEditor.component.less
// module id = 3481
// module chunks = 0